import { parseAddress } from '@libraries/helpers';
import * as parser from 'parse-address';
import { CreateProjectParams } from '../contractor-apply/+state';
import {
  CreateProjectPayload,
  NotEligibleData,
  PreferredLanguage,
  QuestionsFormPayload,
} from '../state';

/**
 * Helps Format Data into consumable
 */

export function formatToCreateProjectPayload(
  data: QuestionsFormPayload,
  preferred_language?: PreferredLanguage
): CreateProjectPayload {
  const parsedAddress = parseAddress(data.baseQuestions.address);
  const ambassador_referral_code = (<any>window).mbsy_short_code;

  const payload: CreateProjectPayload = {
    metadata: {
      how_soon: data.timeframes,
      improvements: data.improvements,
    },

    property_search: {
      address: parsedAddress.line_1,
      city: parsedAddress.city,
      line_2: parsedAddress.line_2,
      state: parsedAddress.state,
      zipcode: parsedAddress.zipcode,
      preferred_language,
      ...(ambassador_referral_code && { ambassador_referral_code }),
    },
    user: {
      email: data.baseQuestions.email,
      phone: data.baseQuestions.phone,
      email_communication: data.baseQuestions.email_communication,
    },
  };
  if (data.promocode) payload.property_search.promo_code = data.promocode;
  return payload;
}

export function constructPropertySearchObj(payload): CreateProjectParams {
  return {
    property_search: payload.address,
    user: {
      email: payload.ownerEmail,
      email_communication: payload.email_communication,
    },
    contractor_email: payload.contractorEmail,
    company_profile_token: payload.token,
    application_source: 'contractor_landing',
  };
}

export function formatToCreateIneligiblePropertyPayload(
  payload
): NotEligibleData {
  const addr = parser.parseLocation(payload.address);
  const street = streetName(addr);
  const { city, state, zip } = addr;
  const { name: ownerName, phone, message } = payload.note;
  const { email, improvements, propertyType, boundaryCode } = payload;

  return {
    ownerName,
    propertyType,
    address: street,
    city,
    state,
    zip,
    email,
    phone,
    message,
    improvements,
    boundaryCode,
  };

  // utility function to create street name from parsed chunks
  function streetName(parsed) {
    const notStreetChunk = {
      city: true,
      state: true,
      zip: true,
    };
    return Object.keys(parsed).reduce((result, chunk, index) => {
      if (notStreetChunk[chunk]) return result;
      const spacer = index === 0 ? '' : ' ';
      return result + spacer + parsed[chunk];
    }, '');
  }
}
